
type MapBackground = {
    [index: number]: number[][];
}

export const mapBackgrounds: MapBackground = {
    1: [
        [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,3, 3, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,3, 3, 3,],
    ],
    2: [
        [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,3, 3, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 3, 3, 3, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 3, 3, 3, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 3, 3, 3, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 3, 3, 3, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,1, 1, 3,],
        [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,3, 3, 3,],
    ],
}
